// services/api.js
import axios from "axios";

// Crear instancia de axios con configuración por defecto
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api',
  withCredentials: true, // Siempre enviar cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para manejar errores globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Manejar error de sesión expirada
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    // Log detallado en desarrollo
    if (process.env.NODE_ENV !== 'production') {
      console.error('--- Global API Error Handled ---');
      console.error('URL:', error.config?.url);
      console.error('Status:', error.response?.status);
      console.error('Message:', error.response?.data?.message || error.message);
      console.error('Details:', error.response?.data?.error || 'N/A');
      console.error('--------------------------------');
    }

    // Retornamos una estructura de error consistente para los componentes
    return Promise.reject({
      message: error.response?.data?.message || 'Error inesperado en el servidor',
      status: error.response?.status,
      originalError: error.response?.data?.error || error
    });
  }
);

export default api;